import { useCallback, useRef } from 'react'
import { ChartInstanceRegistry } from '../store'

interface AI360ChartInstance {
  displayDefaultTooltip: () => void
}

/**
 * Returns a callback ref to attach to a recharts chart component (e.g. `<LineChart ref={...}>`).
 * Registers the chart instance in `ChartInstanceRegistry` as soon as recharts attaches it, and
 * unregisters it on detach/unmount. Unlike an effect keyed on a ref object, a callback ref fires
 * exactly when the underlying instance is attached or detached, so registration still happens
 * correctly even if the chart only mounts once chartData becomes available.
 */
export const useAI360RegisterChartInstance = (): ((instance: AI360ChartInstance | null) => void) => {
  const unregisterRef = useRef<(() => void) | null>(null)

  return useCallback((instance: AI360ChartInstance | null) => {
    unregisterRef.current?.()
    unregisterRef.current = instance ? ChartInstanceRegistry.register(instance) : null
  }, [])
}
